import { render, staticRenderFns } from "./TwoCol2575.vue?vue&type=template&id=0de51a80&"
import script from "./TwoCol2575.vue?vue&type=script&lang=js&"
export * from "./TwoCol2575.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports